import { mapMutations, mapGetters } from "vuex";
import {} from "@/store/mutation-types";

import StarRating from "vue-star-rating";

export default {
    name: "category-item",
    props: ["product"],
    computed: {
        ...mapGetters({}),
    },
    components: {
        StarRating,
    },
    methods: {
        ...mapMutations({}),
    },
};
